import { SET_EMAIL, SET_PREFERENCE, SET_PREFERENCE_STATUS, SET_ORIGINAL_PREFERENCE_STATUS, SET_APPLICATION_TOKEN, SET_IS_LOADING, SET_IDAAS_TOKEN, SET_IDAAS_FAILURE } from '../types';
export const setEmail = email => ({
  type: SET_EMAIL,
  payload: email
});
export const setPreference = value => ({
  type: SET_PREFERENCE,
  payload: value
});
export const setPreferenceStatus = status => ({
  type: SET_PREFERENCE_STATUS,
  payload: status
});
export const setOriginalPreferenceStatus = status => ({
  type: SET_ORIGINAL_PREFERENCE_STATUS,
  payload: status
});
export const setApplicationToken = payload => ({
  type: SET_APPLICATION_TOKEN,
  payload
});
export const setIsLoading = isLoading => ({
  type: SET_IS_LOADING,
  payload: isLoading
});
export const setIdaasToken = token => ({
  type: SET_IDAAS_TOKEN,
  payload: token
});
export const setIdaasFailure = error => ({
  type: SET_IDAAS_FAILURE,
  payload: error
});